<template>
<q-card flat class="cardContent">
  <q-card-section style="margin: 0; padding:5px">
    <div class="text-h6">Filters</div>
  </q-card-section>
  <q-card-section class="scroll cont hide-scrollbar" style="margin: 0; padding:0;">
    <q-list id="filterList" v-if="!visible">
      <q-expansion-item dense group="filterMenu" default-opened style="font-weight: bold;" >
        <template v-slot:header>
          <q-item-section>
            Brand
          </q-item-section>
          <q-item-section side>
            <q-badge :label="brandFilter.length" v-if="brandFilter.length" rounded  />
          </q-item-section>
        </template>
        <div style="font-weight: normal; width:100%; padding-left:5px; margin-bottom:20px">
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="360" label="360" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="AIX" label="AIX" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="Anti Gravity" label="Anti Gravity" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="Arctic Grip" label="Arctic Grip" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="Cheeta" label="Cheeta" />
          <!-- <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="Dimension" label="Dimension" /> -->
          <!-- <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="Element" label="Element" /> -->
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="Elevation" label="Elevation" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="Flathold" label="Flathold" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="Flathold Asia" label="Flathold Asia" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="Grizzly" label="Grizzly" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="ICP" label="ICP" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="Kilter" label="Kilter" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="Kingdom" label="Kingdom" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="Kumiki" label="Kumiki" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="Next" label="Next" />
          <!-- <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="Ocelot" label="Ocelot" /> -->
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="Perfect Descent" label="Perfect Descent" />
          <!-- <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="Satellite" label="Satellite" /> -->
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="Simpl" label="Simpl" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="Tension" label="Tension" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="Trickit" label="TrickIt" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="Urban Plastix" label="Urban Plastix" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="VolX" label="VolX" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="brandFilter" val="Working Class" label="Working Class" />
        </div>
      </q-expansion-item>
      <q-expansion-item dense group="filterMenu" style="font-weight: bold;" >
        <template v-slot:header>
          <q-item-section>
            Type
          </q-item-section>
          <q-item-section side>
            <q-badge :label="typeFilter.length+materialFilter.length+categoriesFilter.length+rangeFilter.length" v-if="typeFilter.length||materialFilter.length||categoriesFilter.length||rangeFilter.length" rounded  />
          </q-item-section>
        </template>
        <div style="font-weight: normal; width:100%; padding-left: 5px; margin-bottom:20px">
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="materialFilter" val="PU" label="Holds PU" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="materialFilter" val="PE" label="Holds PE" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="typeFilter" val="Macro" label="Holds Macro" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="typeFilter" val="Wooden Volume" label="Volumes Wood" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="typeFilter" val="Training Products" label="Training Products" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="typeFilter" val="Climbing Equipment" label="Climbing Equipment" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="categoriesFilter" val="ICP Home Products" label="Home Training" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="categoriesFilter" val="Kids" label="Kids Holds" />
          <q-checkbox dense style="width:100%; padding:1px 4px;" v-model="rangeFilter" val="Speed Holds" label="Speed Holds" />
        </div>
      </q-expansion-item>
      <q-expansion-item group="filterMenu" dense style="font-weight: bold;" >
        <template v-slot:header>
          <q-item-section>
            Colour
          </q-item-section>
          <q-item-section side>
            <q-badge :label="countSelectedGroups" rounded v-if="countSelectedGroups" />
          </q-item-section>
        </template>
        <div style="font-weight: normal; width:100%; padding-left: 0px; margin-bottom:20px">
          <q-list id="superGroupList">
            <q-expansion-item
              dense
              dense-toggle
              v-for="(superGroupColourContent, superGroupColour, superGroupColourIndex) in selectedColours" :key="superGroupColourIndex"
              @show="superGroupColourContent.show = true"
              @hide="superGroupColourContent.show = false"
              >
              <template v-slot:header>
                <q-item>
                  <q-item-section >
                    <q-checkbox dense v-model="superGroupColourContent.selected" @input="v => toggleSuperGroupColour(v,superGroupColourContent)" keep-color>
                      <q-icon :style="{border: '2px solid #747474', backgroundColor: superGroupColourContent.hex, borderRadius: '50px', padding:0, margin:'0 0 0 -5px'}"/>
                      {{ superGroupColour }}
                    </q-checkbox>
                  </q-item-section>
                </q-item>
              </template>

              <q-list id="groupList">
                <q-expansion-item
                  dense
                  dense-toggle
                  v-for="(groupColourContent, groupColour, groupColourIndex) in superGroupColourContent.groups"  :key="`${superGroupColourIndex}-${groupColourIndex}`"
                  @show="groupColourContent.show = true"
                  @hide="groupColourContent.show = false"
                  v-if="superGroupColourContent.show"
                  >

                  <template v-slot:header >
                    <q-item  style="min-height: 26px; padding: 0 9px; width: 100%">
                      <q-item-section >
                        <q-item-label>
                          <q-checkbox dense v-model="groupColourContent.selected" @input="v => toggleGroupColour(v,superGroupColourContent,groupColourContent)">
                            <q-icon :style="{border: '2px solid #747474', backgroundColor: groupColourContent.hex, borderRadius: '50px', padding:0, margin:'0 0 0 -5px'}"/>
                            {{ groupColour }}
                          </q-checkbox>
                        </q-item-label>
                      </q-item-section>
                    </q-item>
                  </template>

                  <q-list id="singleColourList" v-if="groupColourContent.show">
                    <q-item v-for="(colourContent,colour, colourIndex) in groupColourContent.colours"  :key="`${superGroupColourIndex}-${groupColourIndex}-${colourIndex}`">
                      <q-item-section >
                        <q-item-label>
                          <q-checkbox dense v-model="colourContent.selected" @input="updateGroupColour(superGroupColourContent,groupColourContent)">
                            <q-icon :style="{border: '2px solid #747474', backgroundColor: colourContent.hex, borderRadius: '50px', padding:0, margin:'0 0 0 -5px'}"/>
                            {{ colour }}
                          </q-checkbox>
                        </q-item-label>
                      </q-item-section>
                    </q-item>
                  </q-list>
                </q-expansion-item>
              </q-list>

            </q-expansion-item>
          </q-list>
        </div>
      </q-expansion-item>
      <q-expansion-item group="filterMenu" dense style="font-weight: bold;" >
        <template v-slot:header>
          <q-item-section>
            Price
          </q-item-section>
          <q-item-section side>
            <q-badge :label="priceIsSet" v-if="priceIsSet" rounded  />
          </q-item-section>
        </template>
        <div style="font-weight: normal; width:100%; padding-left: 6px; margin-bottom:20px">
          <div style="margin: 40px 20px 0 20px ">
            <q-range
              v-model="priceFilter"
              :min="0"
              :max="10500"
              :step="10"
              :left-label-value="'$' + priceFilter.min || 0"
              :right-label-value="'$' + priceFilter.max || 0"
              label-always
            />
          </div>
          <div class="row justify-center" style="margin: 0 10px;">
            <div class="col-6" style="padding: 0 5px;">
              <q-input
                v-model.number="priceFilter.min"
                type="number"
                label="min"
              />
            </div>
            <div class="col-6" style="padding: 0 5px;">
              <q-input
                v-model.number="priceFilter.max"
                type="number"
                label="max"
              />
            </div>
          </div>
        </div>
      </q-expansion-item>
    </q-list>
    <q-inner-loading :showing="visible" color="primary" />
  </q-card-section>
  <q-card-actions align="right">
    <q-btn dense outline no-caps style="padding: 0 10px; margin:0px" @click="clearAll">Clear all</q-btn>
    <q-btn dense no-caps color="primary" @click="applyFilter" style="padding: 0 15px; margin: 0 10px" v-close-popup>Apply</q-btn>
  </q-card-actions>
</q-card>
</template>

<script>
import { ref } from 'vue'
import { mapGetters, mapState } from 'vuex'
import store from '../store'
import _ from 'lodash'

export default {
  name: 'ProductFilterPopup',
  props: ['filterType', 'addNew'],
  data () {
    let typeFilter = []
    let materialFilter = []
    let categoriesFilter = []
    let rangeFilter = []
    let brandFilter = []
    let priceFilter = ref({ min: 0, max: 10500 })
    let colourFilter = []
    let availableColours = {
      'Green': {
        'hex': '#0f833c',
        'selected': false,
        'show': false,
        'groups': {
          'Dark Green US': {
            'hex': '#0f833c',
            'selected': false,
            'show': false,
            'colours': {
              '16-13': {
                'hex': '#0f833c',
                'selected': false
              }
            }
          },
          'US 16-16 Green': {
            'hex': '#379867',
            'selected': false,
            'show': false,
            'colours': {
              '16-16': {
                'hex': '#379867',
                'selected': false
              },
              'Colour 77': {
                'hex': '#379867',
                'selected': false
              }
            }
          },
          'Fluoro Green': {
            'hex': '#44D62C',
            'selected': false,
            'show': false,
            'colours': {
              '16-29': {
                'hex': '#44D62C',
                'selected': false
              },
              'Colour 12': {
                'hex': '#44D62C',
                'selected': false
              },
              'Pantone 802C (Dimension)': {
                'hex': '#44D62C',
                'selected': false
              },
              'Fluoro Green': {
                'hex': '#44D62C',
                'selected': false
              }
            }
          },
          'Neon Green': {
            'hex': '#5bee76',
            'selected': false,
            'show': false,
            'colours': {
              '16-18': {
                'hex': '#5bee76',
                'selected': false
              }
            }
          },
          'Neon Benky Green': {
            'hex': '#48dc42',
            'selected': false,
            'show': false,
            'colours': {
              '06-06': {
                'hex': '#48dc42',
                'selected': false
              }
            }
          },
          'US 16-09 Green': {
            'hex': '#77cf4e',
            'selected': false,
            'show': false,
            'colours': {
              '16-09': {
                'hex': '#77cf4e',
                'selected': false
              },
              'Colour 69': {
                'hex': '#61993b',
                'selected': false
              }
            }
          },
          '360 Green': {
            'hex': '#61993b',
            'selected': false,
            'show': false,
            'colours': {
              'RAL 6018': {
                'hex': '#61993b',
                'selected': false
              }
            }
          },
          'Mint Green': {
            'hex': '#006f3d',
            'selected': false,
            'show': false,
            'colours': {
              'RAL 6029': {
                'hex': '#006f3d',
                'selected': false
              }
            }
          },
          'Green': {
            'hex': '#48dc42',
            'selected': false,
            'show': false,
            'colours': {
              'Flash Green': {
                'hex': '#48dc42',
                'selected': false
              },
              'Colour 3 Yellow Green': {
                'hex': '#61993b',
                'selected': false
              },
              'Yellow Green': {
                'hex': '#61993b',
                'selected': false
              },
              'Pastel Green': {
                'hex': '#60993b',
                'selected': false
              },
              'Grass Green': {
                'hex': '#61993b',
                'selected': false
              },
              'Pure Green': {
                'hex': '#61993b',
                'selected': false
              },
              'Luminous Green': {
                'hex': '#00b51a',
                'selected': false
              },
              'Lime Green': {
                'hex': '#83BDB9',
                'selected': false
              },
              'Leaf Green': {
                'hex': '#007a33',
                'selected': false
              },
              'US Green': {
                'hex': '#8fad15',
                'selected': false
              },
              'Green': {
                'hex': '#44D62C',
                'selected': false
              },
              'Fluoro Green': {
                'hex': '#44D62C',
                'selected': false
              }
            }
          },
          'Leaf Green': {
            'hex': '#325928',
            'selected': false,
            'show': false,
            'colours': {
              'RAL 6002': {
                'hex': '#325928',
                'selected': false
              },
              'RAL 6002 (Simpl)': {
                'hex': '#325928',
                'selected': false
              }
            }
          },
          '16-16 Green': {
            'hex': '#379867',
            'selected': false,
            'show': false,
            'colours': {
              '16-16': {
                'hex': '#379867',
                'selected': false
              }
            }
          }
        }
      },
      'Red': {
        'hex': '#fc3126',
        'selected': false,
        'show': false,
        'groups': {
          'Red': {
            'hex': '#fc3126',
            'selected': false,
            'show': false,
            'colours': {
              '11-24': {
                'hex': '#fc3126',
                'selected': false
              },
              'RAL 3000': {
                'hex': '#a72920',
                'selected': false
              },
              'Colour 5': {
                'hex': '#bb1e10',
                'selected': false
              },
              'RAL 3020 (Dimension)': {
                'hex': '#bb1e10',
                'selected': false
              },
              'Flame Red': {
                'hex': '#A72920',
                'selected': false
              },
              'Strawberry Red': {
                'hex': '#c63f4a',
                'selected': false
              },
              'Traffic Red': {
                'hex': '#bb1e10',
                'selected': false
              },
              'Pure red': {
                'hex': '#c00d1e',
                'selected': false
              },
              'Red': {
                'hex': '#bb1e10',
                'selected': false
              }
            }
          },
          'STD Red': {
            'hex': '#fd0c1e',
            'selected': false,
            'show': false,
            'colours': {
              '11-12': {
                'hex': '#fd0c1e',
                'selected': false
              }
            }
          },
          'Dark Red': {
            'hex': '#bf0610',
            'selected': false,
            'show': false,
            'colours': {
              '11-01': {
                'hex': '#bf0610',
                'selected': false
              }
            }
          }
        }
      },
      'Orange': {
        'hex': '#ffbf2c',
        'selected': false,
        'show': false,
        'groups': {
          'Pastel Orange': {
            'hex': '#ffbf2c',
            'selected': false,
            'show': false,
            'colours': {
              '14-06': {
                'hex': '#ffbf2c',
                'selected': false
              },
              'RAL 2011': {
                'hex': '#e26e0e',
                'selected': false
              },
              'RAL 2003': {
                'hex': '#f67828',
                'selected': false
              },
              'RAL 2003 (Dimension)': {
                'hex': '#f67828',
                'selected': false
              }
            }
          },
          'Earth Orange': {
            'hex': '#fe9123',
            'selected': false,
            'show': false,
            'colours': {
              '14-04': {
                'hex': '#fe9123',
                'selected': false
              }
            }
          },
          'Fluoro Orange': {
            'hex': '#fd9224',
            'selected': false,
            'show': false,
            'colours': {
              '14-11': {
                'hex': '#fd9224',
                'selected': false
              },
              'Colour 11': {
                'hex': '#ff4d06',
                'selected': false
              },
              'RAL 2005': {
                'hex': '#ff4d06',
                'selected': false
              },
              'RAL 2005 (Dimension)': {
                'hex': '#ff4d06',
                'selected': false
              },
              'Fluoro Orange': {
                'hex': '#ff4d06',
                'selected': false
              }
            }
          },
          'US 14-01 Orange': {
            'hex': '#fc9928',
            'selected': false,
            'show': false,
            'colours': {
              '14-01': {
                'hex': '#fc9928',
                'selected': false
              },
              'Colour 76': {
                'hex': '#fc9928',
                'selected': false
              }
            }
          },
          '360 Orange': {
            'hex': '#f99a1c',
            'selected': false,
            'show': false,
            'colours': {
              'RAL 1033': {
                'hex': '#f99a1c',
                'selected': false
              }
            }
          },
          'Orange': {
            'hex': '#e25303',
            'selected': false,
            'show': false,
            'colours': {
              'RAL 2004': {
                'hex': '#e25303',
                'selected': false
              },
              'Flash Orange': {
                'hex': '#ff4d06',
                'selected': false
              },
              'RAL 2011': {
                'hex': '#e26e0e',
                'selected': false
              },
              'Orange': {
                'hex': '#fc9928',
                'selected': false
              },
              'Yellow Orange': {
                'hex': '#da6e00',
                'selected': false
              },
              'Luminous Orange': {
                'hex': '#ff4d06',
                'selected': false
              },
              'Traffic Orange': {
                'hex': '#dc4405',
                'selected': false
              },
              'Fluoro Orange': {
                'hex': '#ff4d06',
                'selected': false
              }
            }
          },
          '14-01 Orange': {
            'hex': '#fc9928',
            'selected': false,
            'show': false,
            'colours': {
              'Orange': {
                'hex': '#fc9928',
                'selected': false
              }
            }
          }
        }
      },
      'Blue': {
        'hex': '#386cf7',
        'selected': false,
        'show': false,
        'groups': {
          'SkyBlue': {
            'hex': '#386cf7',
            'selected': false,
            'show': false,
            'colours': {
              '13-01': {
                'hex': '#386cf7',
                'selected': false
              },
              'RAL 5015': {
                'hex': '#007cb0',
                'selected': false
              },
              'Colour 7': {
                'hex': '#007cb0',
                'selected': false
              },
              'RAL 5012': {
                'hex': '#0089b6',
                'selected': false
              },
              'RAL 5015 (Dimension)': {
                'hex': '#007cb0',
                'selected': false
              }
            }
          },
          'Light Blue': {
            'hex': '#82c9ff',
            'selected': false,
            'show': false,
            'colours': {
              '13-15': {
                'hex': '#82c9ff',
                'selected': false
              }
            }
          },
          'Dark Blue': {
            'hex': '#103dfd',
            'selected': false,
            'show': false,
            'colours': {
              '13-14': {
                'hex': '#103dfd',
                'selected': false
              }
            }
          },
          'Neon Blue': {
            'hex': '#45b1fd',
            'selected': false,
            'show': false,
            'colours': {
              '13-18': {
                'hex': '#45b1fd',
                'selected': false
              }
            }
          },
          'Blue': {
            'hex': '#007cb0',
            'selected': false,
            'show': false,
            'colours': {
              'Blue': {
                'hex': '#007cb0',
                'selected': false
              },
              'Light blue': {
                'hex': '#0089b6',
                'selected': false
              },
              'Sky Blue': {
                'hex': '#007cb0',
                'selected': false
              },
              'Signal Blue': {
                'hex': '#004ea8',
                'selected': false
              }
            }
          }
        }
      },
      'White': {
        'hex': '#ffffff',
        'selected': false,
        'show': false,
        'groups': {
          'White': {
            'hex': '#ffffff',
            'selected': false,
            'show': false,
            'colours': {
              '12-01': {
                'hex': '#ffffff',
                'selected': false
              },
              'RAL 1201': {
                'hex': '#ffffff',
                'selected': false
              },
              'Colour 79': {
                'hex': '#ffffff',
                'selected': false
              },
              'RAL 9003': {
                'hex': '#ecece7',
                'selected': false
              },
              'Colour 1': {
                'hex': '#f1f0ea',
                'selected': false
              },
              'White': {
                'hex': '#ffffff',
                'selected': false
              },
              'RAL 9010 (Dimension)': {
                'hex': '#ffffff',
                'selected': false
              },
              'Cream': {
                'hex': '#e9e0d2',
                'selected': false
              },
              'Traffic White': {
                'hex': '#f1f0ea',
                'selected': false
              }
            }
          },
          'Snow White': {
            'hex': '#ffffff',
            'selected': false,
            'show': false,
            'colours': {
              '111114': {
                'hex': '#ffffff',
                'selected': false
              }
            }
          }
        }
      },
      'Grey': {
        'hex': '#e7e7e7',
        'selected': false,
        'show': false,
        'groups': {
          'Sender Grey': {
            'hex': '#e7e7e7',
            'selected': false,
            'show': false,
            'colours': {
              '18-12': {
                'hex': '#e7e7e7',
                'selected': false
              }
            }
          },
          'Grey': {
            'hex': '#808080',
            'selected': false,
            'show': false,
            'colours': {
              '18-09': {
                'hex': '#808080',
                'selected': false
              },
              'Grey': {
                'hex': '#8c969d',
                'selected': false
              },
              'Graphite Grey': {
                'hex': '#45494e',
                'selected': false
              },
              'Silver Grey': {
                'hex': '#939ca2',
                'selected': false
              }
            }
          },
          'Charcoal': {
            'hex': '#33404e',
            'selected': false,
            'show': false,
            'colours': {
              '18-03': {
                'hex': '#33404e',
                'selected': false
              }
            }
          },
          'Silver Grey': {
            'hex': '#8c969d',
            'selected': false,
            'show': false,
            'colours': {
              'RAL 7001': {
                'hex': '#8c969d',
                'selected': false
              },
              'RAL 7001 (AIX Wooden Volumes)': {
                'hex': '#8c969d',
                'selected': false
              },
              'RAL 7001 (360)': {
                'hex': '#8c969d',
                'selected': false
              },
              'RAL 7046': {
                'hex': '#7f868a',
                'selected': false
              },
              'RAL 7001 (Dimension)': {
                'hex': '#8c969d',
                'selected': false
              },
              'Silver Grey': {
                'hex': '#8c969d',
                'selected': false
              }
            }
          },
          'Silver Grey ': {
            'hex': '#989EA1',
            'selected': false,
            'show': false,
            'colours': {
              'RAL 7040': {
                'hex': '#989EA1',
                'selected': false
              },
              'RAL7040': {
                'hex': '#989EA1',
                'selected': false
              }
            }
          }
        }
      },
      'Pink': {
        'hex': '#f3a5ed',
        'selected': false,
        'show': false,
        'groups': {
          'US Pink': {
            'hex': '#f3a5ed',
            'selected': false,
            'show': false,
            'colours': {
              '11-20': {
                'hex': '#f3a5ed',
                'selected': false
              }
            }
          },
          'Bright Pink': {
            'hex': '#f82afa',
            'selected': false,
            'show': false,
            'colours': {
              '11-26': {
                'hex': '#f82afa',
                'selected': false
              }
            }
          },
          'Fluoro Pink': {
            'hex': '#e645f8',
            'selected': false,
            'show': false,
            'colours': {
              '11-25': {
                'hex': '#e645f8',
                'selected': false
              },
              'Colour 13': {
                'hex': '#e645f8',
                'selected': false
              },
              'Colour 80': {
                'hex': '#e645f8',
                'selected': false
              },
              'Pantone 806C': {
                'hex': '#e645f8',
                'selected': false
              },
              'Fluoro Pink': {
                'hex': '#e645f8',
                'selected': false
              }
            }
          },
          'Pink': {
            'hex': '#c4618c',
            'selected': false,
            'show': false,
            'colours': {
              'RAL 4003': {
                'hex': '#c4618c',
                'selected': false
              },
              '11-26': {
                'hex': '#f82afa',
                'selected': false
              },
              'Pink': {
                'hex': '#ff3eb5',
                'selected': false
              },
              'Fluoro Pink': {
                'hex': '#e645f8',
                'selected': false
              }
            }
          }
        }
      },
      'Purple': {
        'hex': '#522778',
        'selected': false,
        'show': false,
        'groups': {
          'Dark Purple': {
            'hex': '#522778',
            'selected': false,
            'show': false,
            'colours': {
              '17-16': {
                'hex': '#522778',
                'selected': false
              },
              'Pantone S4050-R60B/M': {
                'hex': '#522778',
                'selected': false
              }
            }
          },
          'Light Purple': {
            'hex': '#c7a4e4',
            'selected': false,
            'show': false,
            'colours': {
              '17-18': {
                'hex': '#c7a4e4',
                'selected': false
              }
            }
          },
          'US 07-13 Purple': {
            'hex': '#800f7f',
            'selected': false,
            'show': false,
            'colours': {
              '07-13': {
                'hex': '#800f7f',
                'selected': false
              },
              'Colour 81': {
                'hex': '#805ead',
                'selected': false
              },
              'Pantone S4050-R60B/M (360 Volume)': {
                'hex': '#49357c',
                'selected': false
              }
            }
          },
          'Signal Violet': {
            'hex': '#844c82',
            'selected': false,
            'show': false,
            'colours': {
              'Colour 16': {
                'hex': '#844c82',
                'selected': false
              },
              'Violet': {
                'hex': '#844c82',
                'selected': false
              }
            }
          },
          'Violet': {
            'hex': '#76689a',
            'selected': false,
            'show': false,
            'colours': {
              'RAL 4005': {
                'hex': '#76689a',
                'selected': false
              },
              'Purple': {
                'hex': '#76689a',
                'selected': false
              }
            }
          },
          'Purple': {
            'hex': '#800f7f',
            'selected': false,
            'show': false,
            'colours': {
              '07-13': {
                'hex': '#800f7f',
                'selected': false
              },
              'Signal Violet': {
                'hex': '#844c82',
                'selected': false
              },
              'Purple 07-13': {
                'hex': '#805ead',
                'selected': false
              },
              'Purple US': {
                'hex': '#8c4799',
                'selected': false
              },
              'Purple': {
                'hex': '#844c82',
                'selected': false
              }
            }
          },
          '07-13 Purple': {
            'hex': '#805ead',
            'selected': false,
            'show': false,
            'colours': {
              'Colour 81': {
                'hex': '#805ead',
                'selected': false
              }
            }
          },
          'Bright Purple': {
            'hex': '#844c82',
            'selected': false,
            'show': false,
            'colours': {
              'Signal Violet': {
                'hex': '#844c82',
                'selected': false
              }
            }
          }
        }
      },
      'Black': {
        'hex': '#000002',
        'selected': false,
        'show': false,
        'groups': {
          'Jet Black': {
            'hex': '#000002',
            'selected': false,
            'show': false,
            'colours': {
              '18-01': {
                'hex': '#000002',
                'selected': false
              },
              'RAL 9005': {
                'hex': '#0e0e10',
                'selected': false
              },
              'Colour 10': {
                'hex': '#0e0e10',
                'selected': false
              },
              'RAL 9005 (Dimension)': {
                'hex': '#0e0e10',
                'selected': false
              },
              'Jet Black': {
                'hex': '#0e0e10',
                'selected': false
              }
            }
          },
          'Black': {
            'hex': '#000000',
            'selected': false,
            'show': false,
            'colours': {
              'Black': {
                'hex': '#000000',
                'selected': false
              },
              '18-01': {
                'hex': '#000002',
                'selected': false
              },
              'Jet Black': {
                'hex': '#0e0e10',
                'selected': false
              }
            }
          }
        }
      },
      'Turquoise': {
        'hex': '#008080',
        'selected': false,
        'show': false,
        'groups': {
          'Teal': {
            'hex': '#008080',
            'selected': false,
            'show': false,
            'colours': {
              '13-27': {
                'hex': '#008080',
                'selected': false
              },
              'Mint': {
                'hex': '#008080',
                'selected': false
              }
            }
          },
          'Pastel Turquoise': {
            'hex': '#7aacac',
            'selected': false,
            'show': false,
            'colours': {
              'RAL 6034 (AIX Wooden Volumes)': {
                'hex': '#7aacac',
                'selected': false
              },
              'RAL 6034': {
                'hex': '#7aacac',
                'selected': false
              }
            }
          }
        }
      },
      'Yellow': {
        'hex': '#fffc38',
        'selected': false,
        'show': false,
        'groups': {
          'Yellow': {
            'hex': '#fffc38',
            'selected': false,
            'show': false,
            'colours': {
              '15-12': {
                'hex': '#fffc38',
                'selected': false
              },
              'RAL 1018': {
                'hex': '#faca30',
                'selected': false
              },
              'Colour 2': {
                'hex': '#f7b500',
                'selected': false
              },
              'RAL 1021': {
                'hex': '#f6b600',
                'selected': false
              },
              'RAL 1018 (Dimension)': {
                'hex': '#faca30',
                'selected': false
              },
              '15-01': {
                'hex': '#fefe36',
                'selected': false
              },
              'Yellow': {
                'hex': '#f6b600',
                'selected': false
              },
              'Traffic Yellow': {
                'hex': '#f7b500',
                'selected': false
              },
              'Bright Yellow': {
                'hex': '#fdda24',
                'selected': false
              },
              'Fluoro Yellow': {
                'hex': '#ffff00',
                'selected': false
              }
            }
          },
          'US Yellow': {
            'hex': '#fefe36',
            'selected': false,
            'show': false,
            'colours': {
              '15-01': {
                'hex': '#fefe36',
                'selected': false
              }
            }
          },
          'Dry Glow Yellow': {
            'hex': '#fffc37',
            'selected': false,
            'show': false,
            'colours': {
              '15-09': {
                'hex': '#fffc37',
                'selected': false
              }
            }
          },
          'Fluoro Yellow': {
            'hex': '#ffff00',
            'selected': false,
            'show': false,
            'colours': {
              'RAL 1026': {
                'hex': '#ffff00',
                'selected': false
              },
              'Fluoro Yellow': {
                'hex': '#ffff00',
                'selected': false
              }
            }
          }
        }
      },
      'Brown': {
        'hex': '#c6846d',
        'selected': false,
        'show': false,
        'groups': {
          'Sienna': {
            'hex': '#c6846d',
            'selected': false,
            'show': false,
            'colours': {
              'RAL 3012': {
                'hex': '#c6846d',
                'selected': false
              }
            }
          },
          'Brown': {
            'hex': '#7e4b26',
            'selected': false,
            'show': false,
            'colours': {
              'Brown 8003': {
                'hex': '#7e4b26',
                'selected': false
              },
              'Signal Brown': {
                'hex': '#794d3e',
                'selected': false
              },
              'Brown': {
                'hex': '#7e4b26',
                'selected': false
              }
            }
          },
          'Sepia Brown ': {
            'hex': '#4a3526',
            'selected': false,
            'show': false,
            'colours': {
              'RAL 8014': {
                'hex': '#4a3526',
                'selected': false
              }
            }
          }
        }
      },
      'Wood': {
        'hex': '#a67138',
        'selected': false,
        'show': false,
        'groups': {
          'Wood': {
            'hex': '#a67138',
            'selected': false,
            'show': false,
            'colours': {
              'Wood': {
                'hex': '#a67138',
                'selected': false
              }
            }
          }
        }
      },
      'Hardware': {
        'hex': '#d9d9d9',
        'selected': false,
        'show': false,
        'groups': {
          'Hardware': {
            'hex': '#d9d9d9',
            'selected': false,
            'show': false,
            'colours': {
              'Hardware': {
                'hex': '#d9d9d9',
                'selected': false
              }
            }
          }
        }
      },
      'Teal': {
        'hex': '#7aacac',
        'selected': false,
        'show': false,
        'groups': {
          'Teal': {
            'hex': '#7aacac',
            'selected': false,
            'show': false,
            'colours': {
              'Teal': {
                'hex': '#7aacac',
                'selected': false
              },
              'Mint': {
                'hex': '#7ebab5',
                'selected': false
              },
              'Turquoise': {
                'hex': '#3eb1c8',
                'selected': false
              }
            }
          }
        }
      },
      'Clear': {
        'hex': '#fff',
        'selected': false,
        'show': false,
        'groups': {
          'Clear': {
            'hex': '#fff',
            'selected': false,
            'show': false,
            'colours': {
              'Clear': {
                'hex': '#fff',
                'selected': false
              }
            }
          }
        }
      },
      'Magenta': {
        'hex': '#bc4077',
        'selected': false,
        'show': false,
        'groups': {
          'Magenta': {
            'hex': '#bc4077',
            'selected': false,
            'show': false,
            'colours': {
              'Magenta': {
                'hex': '#bc4077',
                'selected': false
              }
            }
          }
        }
      },
      'Violet': {
        'hex': '#844c82',
        'selected': false,
        'show': false,
        'groups': {
          'Violet': {
            'hex': '#844c82',
            'selected': false,
            'show': false,
            'colours': {
              'Violet': {
                'hex': '#844c82',
                'selected': false
              }
            }
          }
        }
      },
      'Light Blue': {
        'hex': '#007cb0',
        'selected': false,
        'show': false,
        'groups': {
          'Light Blue': {
            'hex': '#007cb0',
            'selected': false,
            'show': false,
            'colours': {
              'Light Blue': {
                'hex': '#007cb0',
                'selected': false
              }
            }
          }
        }
      },
      'Mint': {
        'hex': '#008080',
        'selected': false,
        'show': false,
        'groups': {
          'Mint': {
            'hex': '#008080',
            'selected': false,
            'show': false,
            'colours': {
              'Mint': {
                'hex': '#008080',
                'selected': false
              }
            }
          }
        }
      },
      'Dark Grey': {
        'hex': '#52595d',
        'selected': false,
        'show': false,
        'groups': {
          'Dark Grey': {
            'hex': '#52595d',
            'selected': false,
            'show': false,
            'colours': {
              'Dark Grey': {
                'hex': '#52595d',
                'selected': false
              }
            }
          }
        }
      },
      'Light Green': {
        'hex': '#61993b',
        'selected': false,
        'show': false,
        'groups': {
          'Light Green': {
            'hex': '#61993b',
            'selected': false,
            'show': false,
            'colours': {
              'Light Green': {
                'hex': '#61993b',
                'selected': false
              }
            }
          }
        }
      },
      'Dark Blue': {
        'hex': '#005387',
        'selected': false,
        'show': false,
        'groups': {
          'Dark Blue': {
            'hex': '#005387',
            'selected': false,
            'show': false,
            'colours': {
              'Dark Blue': {
                'hex': '#005387',
                'selected': false
              }
            }
          }
        }
      },
      'Dune': {
        'hex': '#d5c0a1',
        'selected': false,
        'show': false,
        'groups': {
          'Dune': {
            'hex': '#d5c0a1',
            'selected': false,
            'show': false,
            'colours': {
              'Dune': {
                'hex': '#d5c0a1',
                'selected': false
              }
            }
          }
        }
      },
      'Lime': {
        'hex': '#61993b',
        'selected': false,
        'show': false,
        'groups': {
          'Lime': {
            'hex': '#61993b',
            'selected': false,
            'show': false,
            'colours': {
              'Lime': {
                'hex': '#61993b',
                'selected': false
              }
            }
          }
        }
      }
    }
    let selectedColours = ref({})
    let visible = ref(false)
    selectedColours.value = JSON.parse(JSON.stringify(availableColours))
    let countColourSelected = 0

    function toggleSuperGroupColour (v, superGroupObj) {
      let groups = Object.entries(superGroupObj.groups)
      groups.forEach(([name, group]) => {
        group.selected = v
        let colours = Object.entries(group.colours)
        colours.forEach(([name, colour]) => {
          colour.selected = v
        })
      })
    }

    function toggleGroupColour (v, superGroupObj, groupObj) {
      let colours = Object.entries(groupObj.colours)
      colours.forEach(([name, colour]) => {
        colour.selected = v
        updateGroupColour(superGroupObj, groupObj)
      })
    }

    function updateGroupColour (superGroupObj, groupObj) {
      let colours = Object.entries(groupObj.colours)
      let size = colours.length
      const selectedColoursInGroup = Object.entries(groupObj.colours)
        .filter(([name, colour]) => colour.selected)
        .map(([name, colour]) => name)

      if (size === selectedColoursInGroup.length) {
        groupObj.selected = true
      } else if (!selectedColoursInGroup.length) {
        groupObj.selected = false
      } else {
        groupObj.selected = null
      }
      updateSuperGroupColour(superGroupObj)
    }

    function updateSuperGroupColour (superGroupObj) {
      let { groups } = superGroupObj
      let size = Object.keys(groups).length
      let selectedCount = 0
      let partialSelected = false

      Object.values(groups).forEach(group => {
        if (group.selected) {
          selectedCount++
        } else if (group.selected === null) {
          partialSelected = true
        }
      })

      superGroupObj.selected = selectedCount === size ? true
        : partialSelected || selectedCount ? null
          : false
    }

    function resetColours () {
      selectedColours.value = JSON.parse(JSON.stringify(availableColours))
    }

    function showSpinner () {
      visible.value = true
      setTimeout(() => {
        visible.value = false
      }, 100)
    }

    return {
      typeFilter,
      materialFilter,
      categoriesFilter,
      rangeFilter,
      brandFilter,
      priceFilter,
      colourFilter,
      selectedColours,
      resetColours,
      updateGroupColour,
      updateSuperGroupColour,
      toggleGroupColour,
      toggleSuperGroupColour,
      visible,
      showSpinner,
      countColourSelected
    }
  },
  async mounted () {
    this.clearAll()
    await this.$store.dispatch('filters/waitUntilLoaded')

    if (this.$store.state.filters.filters) {
      let loadedFilters = JSON.parse(JSON.stringify(this.$store.state.filters.filters))
      loadedFilters.forEach(filter => {
        if (filter.type === 'type') {
          this.typeFilter = [...filter.values]
        }
        if (filter.type === 'brand') {
          this.brandFilter = [...filter.values]
        }
        if (filter.type === 'material') {
          this.materialFilter = [...filter.values]
        }
        if (filter.type === 'category') {
          this.categoriesFilter = [...filter.values]
        }
        if (filter.type === 'range') {
          this.rangeFilter = [...filter.values]
        }
        if (filter.type === 'price') {
          this.priceFilter = { min: filter.values.min, max: filter.values.max }
        }

        if (filter.type === 'colour') {
          if (filter.values.superGroups.length > 0) {
            filter.values.superGroups.forEach(superGroupName => {
              this.selectedColours[superGroupName].selected = true
              let groupNames = Object.keys(this.selectedColours[superGroupName].groups)
              groupNames.forEach(groupName => {
                this.selectedColours[superGroupName].groups[groupName].selected = true
                let colourNames = Object.keys(this.selectedColours[superGroupName].groups[groupName].colours)
                colourNames.forEach(colourName => {
                  this.selectedColours[superGroupName].groups[groupName].colours[colourName].selected = true
                })
              })
            })
          }

          if (filter.values.groups.length > 0) {
            filter.values.groups.forEach(content => {
              this.selectedColours[content.superGroup].groups[content.group].selected = true
              this.selectedColours[content.superGroup].selected = null
              let colourNames = Object.keys(this.selectedColours[content.superGroup].groups[content.group].colours)
              colourNames.forEach(colourName => {
                this.selectedColours[content.superGroup].groups[content.group].colours[colourName].selected = true
              })
            })
          }

          if (filter.values.colours.length > 0) {
            filter.values.colours.forEach(content => {
              this.selectedColours[content.superGroup].groups[content.group].colours[content.colour].selected = true
              this.selectedColours[content.superGroup].groups[content.group].selected = null
              this.selectedColours[content.superGroup].selected = null
            })
          }
        }
      })
    }
  },

  computed: {
    ...mapState('auth', ['currentAccount']),
    ...mapGetters('filters', ['colourSuperGroups', 'colourGroups']),
    currentAccount () {
      return store.state.auth.currentAccount
    },
    filters () {
      return this.$store.state.filters.filters
    },
    countSelectedGroups: function () {
      return Object.values(this.selectedColours).filter(sg => sg.selected == true || sg.selected === null).length
    },
    priceIsSet: function () {
      return (this.priceFilter.min != 0 || this.priceFilter.max != 10500) ? 'set' : false
    }
  },
  methods: {
    applyFilter () {
      this.showSpinner()
      let filterParams = {}

      if (this.brandFilter.length > 0) {
        filterParams.brand = this.brandFilter
      }

      if (this.typeFilter.length > 0) {
        filterParams.type = this.typeFilter
      }

      if (this.materialFilter.length > 0) {
        filterParams.material = this.materialFilter
      }

      if (this.categoriesFilter.length > 0) {
        filterParams.category = this.categoriesFilter
      }

      if (this.rangeFilter.length > 0) {
        filterParams.range = this.rangeFilter
      }

      if (this.priceFilter.min != 0 || this.priceFilter.max != 10500) {
        filterParams.price = this.priceFilter
      }

      let col = {
        superGroups: [],
        groups: [],
        colours: []
      }

      let colourKey = Object.keys(this.selectedColours)
      colourKey.forEach(key => {
        if (this.selectedColours[key].selected) {
          col.superGroups.push(key)
        } else if (this.selectedColours[key].selected === null) {
          let groupKey = Object.keys(this.selectedColours[key].groups)
          groupKey.forEach(group => {
            if (this.selectedColours[key].groups[group].selected) {
              col.groups.push({ superGroup: key, group })
            } else if (this.selectedColours[key].groups[group].selected === null) {
              let colourKey = Object.keys(this.selectedColours[key].groups[group].colours)
              colourKey.forEach(colour => {
                if (this.selectedColours[key].groups[group].colours[colour].selected) {
                  col.colours.push({ superGroup: key, group, colour })
                }
              })
            }
          })
        }
      })

      if (col.superGroups.length > 0 || col.groups.length > 0 || col.colours.length > 0) {
        filterParams.colour = col
      }

      let filter = Object.entries(filterParams).map(([key, value]) => ({ type: key, values: value }))
      this.$store.commit('filters/testUpdateFilter', filter)
    },
    clearAll () {
      this.visible = true
      this.typeFilter = []
      this.brandFilter = []
      this.materialFilter = []
      this.categoriesFilter = []
      this.rangeFilter = []
      this.priceFilter = { min: 0, max: 10500 }
      this.colourFilter = []
      this.resetColours()
      this.$store.commit('filters/testUpdateFilter', [])
      this.visible = false
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~quasar-variables';

>>>.q-checkbox {
  font-size: 12px;
}

>>>.q-tabs__arrow {
    padding-top:8px
}

#filterList>>>.q-item {
  padding: 0 2px 0 10px;
}

#superGroupList>>>.q-item {
  padding: 0 0px 0 5px;
  margin: 0px;
  min-height: 26.5px;
  width: 100%;
}

#groupList>>>.q-item {
  padding: 0 5px 0 6px;
  margin: 0px;
  min-height: 26.5px;
  width: 100%;
}

#singleColourList>>>.q-item {
  padding: 0 0 0 22px;
  margin: 0px;
  min-height: 26.5px;
  width: 100%;
}

</style>

<style scoped>

.filterActionBox{
margin: 0;
padding:0;
background-color: #ffdede;
}

.cont {
  /* max-height: calc(100vh - 200px); */


  @media (max-width: 8000px) {
    max-height: calc(100vh - 212px);
  }


  @media (max-width: 919px) {
    max-height: calc(100vh - 150px);
  }

  @media (max-width: 767px) {
    max-height: 100%;
    /* height: calc(100vh - 135px); */
    height: calc(100% - 86px);
  }

}

.cardContent {
  @media (max-width: 767px) {
    width:280px;
    max-width: 280px;
  }




}


</style>
